/* eslint-disable react-hooks/exhaustive-deps */
import { RetweetOutlined } from '@ant-design/icons';
import { Button, Form, Select, Spin } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import ModalConfirm from '../../../../components/Shared/modal/confirm';
import ModalDelete from '../../../../components/Shared/modal/delete';
import ModalDiscardChanges from '../../../../components/Shared/modal/discardChanges';
import useNotify from '../../../../context/Notification/useNotify';
import DataFlowService from '../../../../services/DataFlow.service';
import { useBlocker } from '../../../../util/usePrompt';
import TableDataBase from './components/TableDataBase';
import ModalFail from '../../../../components/Shared/modal/fail';
import IconEnoughData from '../../../../assets/Images/icons/icon-enough-data';
import { ROUTER } from '../../../../constants/router';

const { Option } = Select;

export default function Tab7({
    loading: loadingDatabase,
    databaseInfo,
    getDataBaseDetail,
    getDataFlowDetail,
    editMode,
}) {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    const { businessProcessId } = useParams();
    const [form] = Form.useForm();
    const [departmentList, setDepartmentList] = useState([]);
    const [disabledBtnSync, setDisabledBtnSync] = useState(true);
    const [openDelete, setOpenDelete] = useState(false);
    const [disabledPeriod, setDisabledPeriod] = useState(true);
    const [isOpenFail, setIsOpenFail] = useState(false);
    const [msgError, setMsgError] = useState({
        msg1: '',
        msg2: '',
    });

    // Confirm
    const [openConfirm, setOpenConfirm] = useState(false);
    const [valueSave, setValueSave] = useState();
    const [loading, setLoading] = useState(false);

    const notify = useNotify();

    // Discard change
    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [nextLocation, setNextLocation] = useState(null);
    const [isChangeLocation, setIsChangeLocation] = useState(false);

    useBlocker((nextLocation) => onChangePage(nextLocation), change === true);

    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setIsChangeLocation(true);
        setNextLocation(nextLocation);
    };

    const handelOk = async () => {
        setOpenChange(false);
        setChange(false);
    };

    const handelOkLocation = async () => {
        setOpenChange(false);
        setChange(false);
        setIsChangeLocation(false);
        await form.resetFields();
        await navigate(
            nextLocation.location.pathname + nextLocation.location.search
        );
        await getDataFlowDetail(businessProcessId);
    };

    useEffect(() => {
        getSyncDepartmentList();
    }, []);

    useEffect(() => {
        form.setFieldsValue({ ...databaseInfo });

        if (form.getFieldValue('isSamePeriod')) {
            setDisabledPeriod(true);
        } else {
            setDisabledPeriod(false);
        }
    }, [databaseInfo]);

    useEffect(() => {
        if (!form.getFieldValue('isSamePeriod')) {
            form.setFieldsValue({
                period: '',
            });
        }
    }, [form.getFieldValue()]);

    const getSyncDepartmentList = async () => {
        try {
            const { data } = await DataFlowService.getSyncDepartmentList(
                businessProcessId
            );
            if (data?.resultData) {
                setDepartmentList(data?.resultData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const onFinish = async (value) => {
        if (databaseInfo?.database) {
            setOpenConfirm(true);
            setValueSave(form.getFieldValue());
        } else {
            try {
                const { data } = await DataFlowService.getDataFlowDetail(
                    businessProcessId
                );
                if (data?.resultData) {
                    if (data?.resultData?.collectData) {
                        if (data?.resultData?.categoryPersonalData) {
                            // console.log('have')
                            navigate(
                                `${ROUTER.DS_INVENTORY.DATAFLOW}/sync/${businessProcessId}/${value?.departmentId}`
                            );
                        } else {
                            setMsgError({
                                msg1: t('dataFlow.errMsgTab2'),
                                msg2: t('dataFlow.errMsg2Tab2'),
                            });
                            setIsOpenFail(true);
                        }
                    } else {
                        setMsgError({
                            msg1: t('dataFlow.errMsgTab1'),
                            msg2: t('dataFlow.errMsg2Tab1'),
                        });
                        setIsOpenFail(true);
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }
    };

    const deleteDatabase = async () => {
        await DataFlowService.deleteDatabase(businessProcessId)
            .then((res) => {
                setOpenDelete(false);
                notify({
                    title: t('common.Success'),
                    description: t('dataFlow.SuccessfullyToClearData'),
                });
                changePage();
                getDataFlowDetail();
            })
            .catch((err) => {
                setOpenDelete(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('dataFlow.FailedToClearData'),
                });
            });
    };

    const onChangeDepartmentId = (e) => {
        if (e) {
            setDisabledBtnSync(false);
        }
    };

    const onSubmit = async () => {
        setLoading(true);
        try {
            const { data } = await DataFlowService.updateTabDataBase(valueSave);
            if (data?.resultCode === 1) {
                setOpenChange(false);
                setChange(false);
                getDataBaseDetail();
                setLoading(false);
                setOpenConfirm(false);
                notify({
                    title: t('common.Success'),
                    description: t('Successfully to save data'),
                });
            } else {
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to save data'),
                });
                setOpenConfirm(false);
            }
        } catch (error) {
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('Failed to save data'),
            });
            setOpenConfirm(false);
        }
    };
    const changePage = () => {
        navigate(
            `${ROUTER.DS_INVENTORY.DATAFLOW}/${businessProcessId}/view?tab=5&mode=view`
        );
    };

    return (
        <Spin spinning={loadingDatabase}>
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                onFinish={onFinish}
                form={form}
                layout="vertical"
                onFieldsChange={(_, allFields) => {
                    if (allFields?.length > 1) {
                        setChange(true);
                    } else {
                        setChange(false);
                    }
                }}
            >
                <div className="grid grid-cols-2">
                    <div className="col-span-1">
                        <div className="grid grid-cols-3">
                            <div className="col-span-2">
                                <Form.Item
                                    className="initial"
                                    name="departmentId"
                                >
                                    <Select
                                        size="large"
                                        placeholder={t(
                                            'dataFlow.SelectDepartmentSync'
                                        )}
                                        onChange={onChangeDepartmentId}
                                        disabled={
                                            databaseInfo?.departmentId ||
                                            !editMode
                                        }
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            (option?.children ?? '')
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                        }
                                    >
                                        {departmentList.map((item) => (
                                            <Option
                                                size="large"
                                                key={item.departmentId}
                                                value={item.departmentId}
                                            >
                                                {i18n.language === 'en'
                                                    ? item.departmentNameEn
                                                    : item.departmentNameTh}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </div>
                            <div className="col-span-1 px-2">
                                <Button
                                    hidden={!databaseInfo?.database}
                                    size="large"
                                    type="default"
                                    onClick={() => setOpenDelete(true)}
                                    className="text-[#1890FF] border-[#1890FF] hover:text-blue-400 hover:border-blue-400"
                                >
                                    {t('dataFlow.ClearData')}
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className="col-span-1 flex justify-end">
                        {databaseInfo?.database ? (
                            <>
                                <Button
                                    size="large"
                                    type="default"
                                    className="text-purple-PHX border-purple-PHX w-32 mr-3"
                                    onClick={changePage}
                                >
                                    {t('common.Cancel')}
                                </Button>
                                <Button
                                    size="large"
                                    type="primary"
                                    className="w-32"
                                    htmlType="submit"
                                >
                                    {t('common.Save')}
                                </Button>
                            </>
                        ) : (
                            <Button
                                disabled={disabledBtnSync}
                                size="large"
                                type="primary"
                                htmlType="submit"
                                icon={<RetweetOutlined />}
                            >
                                {t('dataFlow.SyncData')}
                            </Button>
                        )}
                    </div>
                    <TableDataBase
                        databaseInfo={databaseInfo}
                        viewMode={false}
                        form={form}
                        disabledPeriod={disabledPeriod}
                        setDisabledPeriod={setDisabledPeriod}
                    />
                </div>
            </Form>

            <ModalConfirm
                loading={loading}
                text={t('Do you want to confirm')}
                open={openConfirm}
                handelOk={onSubmit}
                handelClose={() => setOpenConfirm(false)}
            />
            <ModalDelete
                open={openDelete}
                text={t('dataFlow.DoYouWantToClearData')}
                title={t('dataFlow.ConfirmClearData')}
                handelOk={() => {
                    deleteDatabase();
                }}
                handelClose={() => setOpenDelete(false)}
            />

            <ModalDiscardChanges
                open={openChange}
                handelOk={isChangeLocation ? handelOkLocation : handelOk}
                handelClose={() => setOpenChange(false)}
            />
            <ModalFail
                icon={<IconEnoughData />}
                open={isOpenFail}
                title={t('dataFlow.notEnoughInformation')}
                text={
                    <>
                        {msgError?.msg1} <br />
                        {msgError?.msg2}
                    </>
                }
                handelClose={() => setIsOpenFail(false)}
            />
        </Spin>
    );
}
